import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { useMessageStack } from "../../../../core/MessageStack/useMessageStack";
import { messagesSlice } from "frontend/components/fort/mod/photos/slices/messagesSlice.js";

const Messages = () => {
    const { addMessages } = useMessageStack();
    const dispatch = useDispatch();
    const { messages } = useSelector(state => state.messages);

    useEffect(() => {
        messages.forEach(message => {
            addMessages([message]);
            dispatch(messagesSlice.actions.removeMessage(message.id));
        });
    }, [messages]);

    return null;
};

export default Messages;
